module.exports = __webpack_public_path__ + "img/banner_info.c10e922f.png";